import { FormWithRedux } from '../../FormWithRedux';
import { ACCBISTOrientationCheck4Form } from './ACCBIST-OrientationCheck4Form';
import { ACCBISTRecollectionCheck4Form } from './ACCBIST-RecollectionCheck4Form';
import { ACCBISTRecollectionFailureCheck4Form } from './ACCBIST-RecollectionFailureCheck4Form';
import moment from 'moment';

import { FormValidationError } from '../../../waferJS/Form/Validation/FormValidationError';
import { FormValidation } from '../../../waferJS/Form/Validation/FormValidation';

export class ACCBISTAWPTA4Form extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('awptaCheck4Subform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    generateSubform(identifier) {
        switch(identifier) {
            case 'orientationCheck4Subform':
                return new ACCBISTOrientationCheck4Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'recollectionCheck4Subform':
                return new ACCBISTRecollectionCheck4Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'recollectionFailureCheck4Subform':
                return new ACCBISTRecollectionFailureCheck4Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        return true;
    }

    getValueType(identifier) {
        return 'date';
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        if (identifier == 'awptaCheck4DateTime') {
            let self = this;

            let timeConflict = new FormValidation('AbnormalitiesPresentConflict', function () {
                let value = self.getValue(identifier);
                let check1Value = self.getValue('awptaCheck3DateTime');
                if (value != null && value!= undefined && check1Value != null && check1Value != undefined) {
                    let firstCheck = moment(new Date(check1Value));
                    let secondCheck = moment(new Date(value));
                    var duration = moment.duration(secondCheck.diff(firstCheck));
                    var hours = duration.asHours();

                    if (hours < 1) {
                        return [new FormValidationError(FormValidationError.FormErrorType.warning, 'Current check should be at least 1 hour after the previous.')];
                    }
                    else {
                        return [];
                    }
                
                }
                else {
                    return [];
                }
            });
            return [timeConflict];
        }
        
        return [];
    }

    detailForIdentifier(prefix, value) {
        if(value.identifier == 'gcsSubform') {
            return null;
        }
        
        return super.detailForIdentifier(prefix, value);
    }

    htmlForIdentifier(prefix, value) {
        if(value.identifier == 'gcsSubform') {
            return null;
        }
        else {
            return super.htmlForIdentifier(prefix, value);
        }
    }

    shouldShowInSidebar() {
        if(this.getValue('awptaCheck3DateTime') != null && this.getValue('awptaCheck3DateTime') != undefined) {
            return true;
        }

        return false;
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-AWPTA4Form.js